import { useDashboardStore, useFetchFarmerDashboard } from '@features/dashboard/store';
import { useAppbarTitle } from '@hooks/useAppbarTitle';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { usePageTitle } from '@hooks/usePageTitle';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import FieldBookComingSoonImage from 'assets/images/fieldBookComingSoon.png';
import ServicesCardImage from 'assets/images/servicesCard.png';
import { useTranslation } from 'react-i18next';
import { RequestsAndOffers } from './components/RequestsAndOffers';
import { Services } from './components/Services';

export const DashboardFarmerPage = () => {
	const { navigateWithLanguage } = useLanguageNavigate();
	const { t } = useTranslation();

	usePageTitle(t('dashboardPage'));
	useAppbarTitle('dashboardPage');

	const { farmerData } = useDashboardStore();

	useFetchFarmerDashboard();

	return (
		<div className="w-full h-full max-w-[1440px] mx-auto">
			<div className="flex justify-start items-center">
				<h2 className="md:text-2xl font-bold mb-6 mt-5">{t('services')}</h2>
			</div>
			<div className="md:flex hidden">
				<Services />
			</div>
			<div
				className="md:hidden cursor-pointer flex relative flex-col justify-center items-center h-[208px] text-white rounded-xl shadow-lg w-full md:h-full bg-cover bg-top"
				style={{ backgroundImage: `url(${ServicesCardImage})` }}
				onClick={() => navigateWithLanguage('/farmer/services')}
			>
				<div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/50 rounded-xl"></div>
				<div className="relative flex flex-col items-center text-center text-white">
					<span className="font-roboto font-bold text-2xl uppercase">{t('services')}</span>
				</div>
			</div>
			<div className="w-full bg-light my-5 md:h-[1px] h-0" />
			<div className="hidden md:block">
				<RequestsAndOffers data={farmerData?.data} />
			</div>
			<div className="md:hidden flex flex-col gap-6">
				<div
					className="shadow-lg relative flex justify-center items-center w-full bg-white border-l-[10px] border-l-primary rounded-[7px] text-dark font-bold text-base font-roboto py-6"
					onClick={() => navigateWithLanguage('/farmer/view-offers')}
				>
					{t('requestsOffers')}
					<div className="absolute right-4">
						<KeyboardArrowRightIcon />
					</div>
				</div>
				<div
					className="shadow-lg relative flex justify-center items-center w-full bg-primary border-l-[10px] border-l-[#038877] rounded-[7px] text-white font-bold text-base font-roboto py-6"
					onClick={() => navigateWithLanguage('/farmer/monitoring/ongoing-projects')}
				>
					{t('ongoingMonitoring')}
					<span className="ml-[4px]">({farmerData?.data?.services?.monitoring.active || 0})</span>
					<div className="absolute right-4">
						<KeyboardArrowRightIcon />
					</div>
				</div>
			</div>
			<div className="w-full bg-light my-5 md:h-[1px] h-0" />
			<div className="flex gap-6 xl:flex-nowrap flex-wrap">
				<div
					className="relative flex flex-col justify-center items-center md:py-0 py-3 md:h-[208px] text-white rounded-xl shadow-lg w-full h-full bg-cover bg-center"
					style={{ backgroundImage: `url(${FieldBookComingSoonImage})` }}
				>
					{/* Gradient Overlay */}
					<div className="absolute inset-0 bg-gradient-to-b from-white/30 to-white/30 rounded-xl"></div>

					{/* Content (Placed Above the Overlay) */}
					<div className="relative flex flex-col items-center text-center text-white">
						<span className="font-roboto font-bold text-2xl uppercase">Fieldbook</span>
						<span className="font-roboto font-base font-normal">Coming Soon</span>
					</div>
				</div>
				{/* Chat widget hidden for farmers */}
				{/* <div className="hidden md:block w-full">
					<ChatCard />
				</div> */}
			</div>
		</div>
	);
};
